import { cn } from '@/lib/utils';

const SPORT_CONFIG: Record<string, { emoji: string; label: string; color: string; bg: string; border: string }> = {
  football: { emoji: '🏈', label: 'Football', color: 'text-[#C9A84C]', bg: 'bg-[#C9A84C]/[0.06]', border: 'border-l-[#C9A84C]' },
  soccer: { emoji: '⚽', label: 'Soccer', color: 'text-[#2D9B4F]', bg: 'bg-[#2D9B4F]/[0.06]', border: 'border-l-[#2D9B4F]' },
  basketball: { emoji: '🏀', label: 'Basketball', color: 'text-[#E8651A]', bg: 'bg-[#E8651A]/[0.06]', border: 'border-l-[#E8651A]' },
  baseball: { emoji: '⚾', label: 'Baseball', color: 'text-[#C8443A]', bg: 'bg-[#C8443A]/[0.06]', border: 'border-l-[#C8443A]' },
};

interface SportIndicatorProps {
  sport: string;
  className?: string;
}

export function SportIndicator({ sport, className }: SportIndicatorProps) {
  const config = SPORT_CONFIG[sport] || SPORT_CONFIG.football;

  return (
    <div className={cn('flex items-center gap-2 px-3 py-2 rounded-r-lg border-l-[3px]', config.bg, config.border, className)}>
      <span>{config.emoji}</span>
      <span className={cn('text-sm font-display font-medium', config.color)}>{config.label}</span>
    </div>
  );
}
